import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import Loader from "../loader/Loader";
import { sentPostMessage } from "src/utils/utils";
import { API_RESULT } from "src/utils/enums";

interface FailureProps {
  className?: string;
}

const Failure: React.FC<FailureProps> = ({ className }) => {
  useEffect(() => {
    console.log("$$$ Hello from Failure Iframe");
    sentPostMessage({
      status: API_RESULT.FAILED,
    });
  }, []);

  return (
    <div className={styles.failureContainer}>
      <div className={styles.loaderWrapper}>
        <Loader fullHeight={false} />
      </div>
    </div>
  );
};

export default Failure;
